import React, { useState } from 'react';
import styles from './index.module.css';
import AvatarComponent from '@components/AvatarComponent';
import I18n from '@utils/i18n';
import cn from 'classnames';
import helper from '@utils/helper';
import { getClient } from '@api/feedStream'
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import { FollowBtn } from '@widget/community'

const T = (props) => {
  const { itemData = {}, userId } = props;
  const { customerMisc } = itemData;
  const identificationSource = helper.identificationSwitch(customerMisc?.role);
  const avatar = customerMisc?.avatar || require('@images/defaultAvatar.webp');
  const [userInfo, setUserInfo] = useState({})
  const fetchUserData = async (id) => {
    const userData = await getClient()
      .user(id)
      .get({})
    if (userData?.full?.result) {
      setUserInfo(userData.full.result)
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (customerMisc?.customerId) {
      fetchUserData(customerMisc.customerId);
    }
  }, [customerMisc?.customerId])

  return (
    <>
      <div className={styles.avatar}>
        <AvatarComponent
          customerId={customerMisc?.customerId}
          avatar={avatar}
          avatarSize={72}
          identificationSource={identificationSource}
          identificationSize={24}
        />
      </div>
      <div className={cn(styles.name, 'DINPro-Medium')}>
        {customerMisc?.nickName ?? ''}
      </div>
      <div className={styles.infoList}>
          {
            [
              { count: userInfo?.followingCount, key: I18n.t('profile_follow') },
              { count: userInfo?.followerCount, key: I18n.t('profile_followers') }
            ].map((item) => {
              return (
                <span key={item.key} className={styles.infoRow}>
                    <span className={cn(styles.count, 'DINPro-Medium')}>{item.count ?? '0'}</span>
                    <span className={cn(styles.countText, 'DINPro-Medium')}>{item.key}</span>
                </span>
              )
            })
          }
      </div>
      <p className={cn(styles.intro, 'DINPro')}>
        {customerMisc?.intro ?? ''}
      </p>
      <div className={styles.btnContainer}>
        {userId !== customerMisc?.customerId
          ? (<FollowBtn
            className={styles.btn}
            type="primary"
            size="lg"
            isFollow={userInfo?.isFollower}
            toCustomerId={userInfo?.customerId}
          />)
          : null
        }
      </div>
    </>
  )
}

export default T
